/**
 * Contract every analytics destination (GA4, GTM, Mixpanel, ...) must
 * implement. AnalyticsService only ever talks to this shape, so adding a new
 * destination never requires touching the pages/components that fire events.
 */
export default class AnalyticsAdapter {
  /** One-time setup (load SDK, configure IDs). May be called only once. */
  initialize() {
    throw new Error(`${this.constructor.name} must implement initialize()`);
  }

  /** @param {string} path e.g. "/keyword-analysis" @param {string} [title] */
  trackPageView(path, title) {
    throw new Error(`${this.constructor.name} must implement trackPageView()`);
  }

  /**
   * @param {string} name event name, e.g. "search_performed"
   * @param {Record<string, unknown>} [params]
   */
  trackEvent(name, params) {
    throw new Error(`${this.constructor.name} must implement trackEvent()`);
  }

  /** @param {string|null} userId null/undefined clears identity (logout) */
  setUser(userId) {
    throw new Error(`${this.constructor.name} must implement setUser()`);
  }

  /** @param {Record<string, unknown>} properties non-PII user-scoped properties */
  setUserProperties(properties) {
    throw new Error(`${this.constructor.name} must implement setUserProperties()`);
  }
}
